const UmsUserManagementActionTypes = {
  FETCH_UMS_PRIVILEGES_START: 'FETCH_UMS_PRIVILEGES_START',
  FETCH_UMS_PRIVILEGES_SUCCESS: 'FETCH_UMS_PRIVILEGES_SUCCESS',
  FETCH_UMS_PRIVILEGES_FAILURE: 'FETCH_UMS_PRIVILEGES_FAILURE',

  FETCH_UMS_ROLES_START: 'FETCH_UMS_ROLES_START',
  FETCH_UMS_ROLES_SUCCESS: 'FETCH_UMS_ROLES_SUCCESS',
  FETCH_UMS_ROLES_FAILURE: 'FETCH_UMS_ROLES_FAILURE',

  FETCH_UMS_SINGLE_ROLE_START: 'FETCH_UMS_SINGLE_ROLE_START',
  FETCH_UMS_SINGLE_ROLE_SUCCESS: 'FETCH_UMS_SINGLE_ROLE_SUCCESS',
  FETCH_UMS_SINGLE_ROLE_FAILURE: 'FETCH_UMS_SINGLE_ROLE_FAILURE',

  SAVE_ROLE_START: 'SAVE_ROLE_START',
  EDIT_ROLE_START: 'EDIT_ROLE_START',
  EDIT_ROLE_SUCCESS: 'EDIT_ROLE_SUCCESS',
  SAVE_ROLE_SUCCESS: 'SAVE_ROLE_SUCCESS',
  SAVE_ROLE_FAILURE: 'SAVE_ROLE_FAILURE',

  DELETE_ROLE_START: 'DELETE_ROLE_START',
  DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',
  DELETE_ROLE_FAILURE: 'DELETE_ROLE_FAILURE',

  FETCH_UMS_USERS_START: 'FETCH_UMS_USERS_START',
  FETCH_UMS_USERS_SUCCESS: 'FETCH_UMS_USERS_SUCCESS',
  FETCH_UMS_USERS_FAILURE: 'FETCH_UMS_USERS_FAILURE',

  FETCH_UMS_SINGLE_USER_START: 'FETCH_UMS_SINGLE_USER_START',
  FETCH_UMS_SINGLE_USER_SUCCESS: 'FETCH_UMS_SINGLE_USER_SUCCESS',
  FETCH_UMS_SINGLE_USER_FAILURE: 'FETCH_UMS_SINGLE_USER_FAILURE',

  FETCH_USER_STATISTICS_START: 'FETCH_USER_STATISTICS_START',
  FETCH_USER_STATISTICS_SUCCESS: 'FETCH_USER_STATISTICS_SUCCESS',
  FETCH_USER_STATISTICS_FAILURE: 'FETCH_USER_STATISTICS_FAILURE',

  SET_ANY_DATA: 'SET_ANY_DATA',
};

export default UmsUserManagementActionTypes;
